import React, { useState, useEffect, useContext } from "react";
import UserProductReadOnlyRow from "./UserProductReadOnlyRow";
import UserProductTableRow from "./UserProductTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function UserProductTable({ key, setProduct, loginId, companyId }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const [error, setError] = useState("");
    const [isProductLoading, setIsProductLoading] = useState(false);
    const [isUserLoading, setIsUserLoading] = useState(false);
    const [commodityList, setCommodityList] = useState([]);
    const [products, setProducts] = useState([]);
    const [userProducts, setUserProducts] = useState([]);
    const [count, setCount] = useState(key);
    const closeText = t("page.close");
    const userCtx = useContext(UserContext);

    const initialValues = {
        loginId: loginId,
        companyId: companyId,
        commodityKey: 0,
        companyProductKey: 0,
    };
    const [formValues, setFormValues] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };

    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
    useEffect(() => {
        fetchProducts();
        fetchUserProducts();
    }, []);

    const handleClose = (event) => {
        setProduct(false);
    };

    function fetchProducts() {
        if (initialValues.companyId || initialValues.companyId > 0) {
            fetchCompanyProduct();
        } else {
            fetchCommodity();
        }

    }
    function fetchCompanyProduct() {
        setError("");
        if (!initialValues.companyId || initialValues.companyId === 0) {
            return;
        }

        setIsProductLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false, companyId: initialValues.companyId
            }),
        };
        try {
            FetchUtil.fetchAPI("GetCompanyProduct", "/Service/CompanyService/GetCompanyProduct", requestOptions, retrieveCompanyProductSuccess, retrieveCompanyProductFail);
        } catch (error) {
            setIsProductLoading(false);
            throw new Error(error.message);
        }
    }

    function retrieveCompanyProductFail(redirect) {
        setIsProductLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getProdFailed"));
    }

    function retrieveCompanyProductSuccess(responseData) {
        let getCompanyProductResponse;
        if (responseData) {
            getCompanyProductResponse = responseData.getCompanyProductResponse;
            if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "0") {
                setProducts(getCompanyProductResponse.products.slice())
            } else if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getCompanyProductResponse) {
                setError(t("error.error") + " " + getCompanyProductResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsProductLoading(false);
    }

    function fetchCommodity() {
        setError("");
        setIsProductLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false
            }),
        };
        try {
            FetchUtil.fetchAPI("MGetCommodity", "/Service/StaticHelper/GetCommodity", requestOptions, getCommoditySuccess, getCommodityFail);
        } catch (error) {
            setIsProductLoading(false);
            throw new Error(error.message);
        }
    }

    function getCommodityFail(redirect) {
        setIsProductLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getProdFailed"));
    }

    function getCommoditySuccess(responseData) {
        let getCommodityResponse;
        if (responseData) {
            getCommodityResponse = responseData.getCommodityResponse;
            if (getCommodityResponse && getCommodityResponse.errorCode === "0") {
                setCommodityList(getCommodityResponse.commodityList.slice())
            } else if (getCommodityResponse && getCommodityResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getCommodityResponse) {
                setError(t("error.error") + " " + getCommodityResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsProductLoading(false);
    }

    function fetchUserProducts() {
        setError("");
        if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
            return;
        }
        resetCounter();
        setIsUserLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true, companyId: initialValues.companyId,
                loginId: initialValues.loginId, userCompanyId: userCompanyId
            }),
        };
        try {
            FetchUtil.fetchAPI("GetUserProduct", "/Service/UserService/GetUserProduct", requestOptions, retrieveUserProductSuccess, retrieveUserProductFail);
        } catch (error) {
            setIsUserLoading(false);
            throw new Error(error.message);
        }
    }

    function retrieveUserProductFail(redirect) {
        setIsUserLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.userGetProdFailed"));
    }

    function retrieveUserProductSuccess(responseData) {
        let fetchUserProductsResponse;
        if (responseData) {
            fetchUserProductsResponse = responseData.fetchUserProductsResponse;
            if (fetchUserProductsResponse && fetchUserProductsResponse.errorCode === "0") {
                setUserProducts(fetchUserProductsResponse.products.slice())
            } else if (fetchUserProductsResponse && fetchUserProductsResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchUserProductsResponse) {
                setError(t("error.error") + " " + fetchUserProductsResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsUserLoading(false);
    }

    const handleDeleteClick = (event, userProductItem, completeCallback) => {
        event.preventDefault();
        deleteUserProduct(userProductItem, completeCallback);
    };
    const deleteUserProduct = (userProductItem, completeCallback) => {
        let action = 3;
        if (userProductItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            loginId: formValues.loginId,
            commodityKey: userProductItem.commodityKey,
            companyProductKey: userProductItem.companyProductKey,
            userCompanyId: userCompanyId,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("DeleteUserProduct", "/Service/UserService/DeleteUserProduct", requestOptions, deleteUserProductSuccess, deleteUserProductFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function deleteUserProductFail(redirect, completeCallback) {
        setError(t("error.userProdEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deleteUserProductSuccess(responseData, completeCallback) {
        let deleteUserProductResponse;
        if (responseData) {
            deleteUserProductResponse = responseData.deleteUserProductResponse;
            if (deleteUserProductResponse) {
                if (deleteUserProductResponse.errorCode === "0") {
                    resetRowTable();
                    refreshUserProduct();
                } else {
                    setError(t("error.error") + " " +
                        deleteUserProductResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    function refreshUserProduct() {
        fetchUserProducts();
    }
    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };
    const addRowTable = () => {
        setError("");
        if (!add) {
            setAdd(true);
        } else {
            setError(t("error.only1RowAllowed"));
        }

    };
    const removeRowTable = () => {
        setError("");
        resetRowTable();
    };
    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
    };
    const handleSubmit = (action, setValues, completeCallback) => {
        setError("");
        let found = false;
        if (!formValues.loginId) {
            setError(t("error.userReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (userProducts.length > 0) {
                userProducts.map((userProductItem, index) => {
                    if (userProductItem.commodityKey === setValues.commodityKey && userProductItem.companyProductKey == setValues.companyProductKey) {
                        setError(t("error.prodDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                saveUserProduct(action, setValues, completeCallback);
            }
        }
    };
    const saveUserProduct = (action, setValues, completeCallback) => {
        let serverParams = {
            loginId: formValues.loginId,
            companyId: formValues.companyId,
            commodityKey: setValues.commodityKey,
            companyProductKey: setValues.companyProductKey,
            userCompanyId: userCompanyId,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdateUserProduct", "/Service/UserService/AddUpdateUserProduct", requestOptions, saveUserProductSuccess, saveUserProductFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function saveUserProductFail(redirect, completeCallback) {
        setError(t("error.userProdEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function saveUserProductSuccess(responseData, completeCallback) {
        let addUpdateUserProductResponse;
        if (responseData) {
            addUpdateUserProductResponse = responseData.addUpdateUserProductResponse;
            if (addUpdateUserProductResponse) {
                if (addUpdateUserProductResponse.errorCode === "0") {
                    resetRowTable();
                    refreshUserProduct();
                } else {
                    setError(t("error.error") + " " +
                        addUpdateUserProductResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    return (
        <>
            {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                <div className="container-fluid container_list_sm viewh-85">
                    <div className="row">
                        <div className="col mt-3">
                            {(error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                        {(isProductLoading || isUserLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <table className="list-table" role="table">
                                <thead>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.productGrp")}</th>
                                        <th className="list-th" style={{ maxWidth: "20vw", minWidth: "12vw" }}>{t("page.commoName")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.prodName")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.prodNum")}</th>
                                        <th className="list-th" style={{ maxWidth: "17vw" }}>{t("page.description")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    {add && addRowTop &&
                                        <UserProductTableRow
                                            key={count}
                                            companyId={companyId}
                                            commodityList={commodityList}
                                            products={products}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((userProducts.length % 2) > 0) ? true : false} />
                                    }
                                    {(userProducts.length > 0) ? (
                                        userProducts.map((userProductItem, index) => (
                                            <UserProductReadOnlyRow
                                                key={count}
                                                t={t}
                                                userProductItem={userProductItem}
                                                handleDeleteClick={handleDeleteClick}
                                                oddIdx={((index % 2) > 0) ? true : false}
                                                add={add}
                                                setError={setError}
                                                handleSubmit={handleSubmit}
                                            />
                                        ))
                                    ) : (<></>)}
                                    {add && addRowBottom &&
                                        <UserProductTableRow
                                            key={count}
                                            companyId={companyId}
                                            commodityList={commodityList}
                                            products={products}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((userProducts.length % 2) > 0) ? true : false} />
                                    }
                                </tbody>
                                {(userProducts.length > 10) ? (<tfoot>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.productGrp")}</th>
                                        <th className="list-th" style={{ maxWidth: "20vw", minWidth: "12vw" }}>{t("page.commoName")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.prodName")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.prodNum")}</th>
                                        <th className="list-th" style={{ maxWidth: "17vw" }}>{t("page.description")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </tfoot>
                                ) : (<></>)}
                            </table>
                            <div className="row">
                                <div className="col mt-3">
                                    {(error) ? (
                                        <div id="inerrorMessage1" className="errorblock">
                                            {error}
                                        </div>
                                    ) : (<></>)}
                                </div>
                            </div>
                            <div className="footer">
                                <input
                                    type="button"
                                    name="edit-user-prod-close"
                                    id="edit-user-prod-close"
                                    className="btn btn-secondary btn-block" data-dismiss="modal"
                                    onClick={(e) => handleClose(e)}
                                    style={{ marginTop: "10px", marginBottom: "10px" }}
                                    value={closeText}
                                ></input>
                            </div>
                        </div>
                    </div>
                </div>
                : null}
        </>
    );
}
export default UserProductTable;